import React from "react";
import { DropTarget } from "react-dnd";
import { ItemTypes } from "./ItemTypes";
import { Segment, Header, Form } from "semantic-ui-react";
import RoomDragContext from "./RoomDragContext";
const columnTarget = {
  drop(props) {
    props.moveItem(props.transfer);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}
const RoomsDropTarget = ({
  connectDropTarget,
  isOver,
  header,
  setDragging,
  rooms,
  checkRoom,
  uncheckRoom,
  transfer,
  setKeyword,
  keyword,
  t
}) => {
  return connectDropTarget(
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%"
      }}>
      <Segment color={isOver ? "yellow" : undefined}>
        <Header as="h3">{header}</Header>
        <Form.Input
          type="text"
          onChange={(proxy, input) => setKeyword(input.value)}
          value={keyword}
          placeholder={t("cleaning:filterText")}
        />
        {rooms.map(room => (
          <RoomDragContext
            key={room.roomId}
            room={room}
            setDragging={setDragging}
            toggleRoom={() => {
              transfer.find(r => r.roomId === room.roomId)
                ? uncheckRoom(room)
                : checkRoom(room);
            }}
            transfer={transfer}
            active={transfer.find(r => r.roomId === room.roomId)}
          />
        ))}
      </Segment>
    </div>
  );
};

export default DropTarget(ItemTypes.ROOM, columnTarget, collect)(
  RoomsDropTarget
);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/RoomsDropTarget.js